export enum StatusTranslationKey {
  Occupied = 'general.occupied',
  PartlyOccupied = 'general.assign_to_shift',
  NotOccupied = 'general.not_occupied',
}
